import Card from '../common/Card';
import { formatTournamentDateTime } from '../../utils/dateTime';
import './TournamentCard.css';

export default function TournamentCard({ tournament, variant = 'circuit' }) {
  const isNonCircuit = variant === 'non-circuit';

  return (
    <Card className="tournament-card">
      <div className="tournament-card__header">
        <span className={`tournament-card__badge ${isNonCircuit ? 'tournament-card__badge--featured' : 'tournament-card__badge--sponsored'} staatliches-regular`}>
          {isNonCircuit ? 'Mis en avant' : 'Champions Collective'}
        </span>
        {tournament.date && (
          <span className="tournament-card__date chiron-goround-tc-light">
            {formatTournamentDateTime(tournament.date, tournament.time, { style: 'long' })}
          </span>
        )}
      </div>

      <h3 className="tournament-card__name staatliches-regular">{tournament.name}</h3>

      <div className="tournament-card__meta chiron-goround-tc-body">
        {tournament.maxPlayers && (
          <span className="tournament-card__players">
            Max {tournament.maxPlayers} joueurs
          </span>
        )}
        {tournament.format && (
          <span className="tournament-card__format">
            {tournament.format}
          </span>
        )}
        {tournament.gameType && (
          <span className="tournament-card__game-type">
            {tournament.gameType}
          </span>
        )}
        {tournament.topCut && (
          <span className="tournament-card__top-cut">
            Top Cut : {tournament.topCut}
          </span>
        )}
      </div>

      {tournament.limitlessUrl && (
        <a
          href={tournament.limitlessUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="tournament-card__cta staatliches-regular"
        >
          Voir le tournoi sur Limitless →
        </a>
      )}
    </Card>
  );
}
